export default __webpack_public_path__ + "static/media/circles.8705cf61.png";